<script lang="ts">
	import type { TabCaseItem } from '$lib_commons/models/TabCase.ts'
	import { type Writable } from 'svelte/store'
	import { Icon } from '@repo/commons/components'

	interface Props {
		tabs?: Writable<TabCaseItem[]> | TabCaseItem[]
		onpress?: (id: string) => void
		disabled?: boolean
	}

	let { tabs = [], onpress, disabled = false }: Props = $props()

	let tabsArray = $state<TabCaseItem[]>([])

	$effect(() => {
		const t = tabs
		if (t == null) {
			tabsArray = []
			return
		}
		if ('subscribe' in t) {
			const store = t as Writable<TabCaseItem[]>
			const unsub = store.subscribe((value) => {
				tabsArray = value
			})
			return unsub
		}
		tabsArray = t as TabCaseItem[]
	})
</script>

<div class="tabs" class:tabs--disabled={disabled}>
	{#each tabsArray as tab}
		<button
			type="button"
			class="item {tab.isActive ? 'active' : ''}"
			onclick={() => (!disabled ? onpress?.(String(tab.id)) : null)}
		>
			{#if tab.icon}
				<Icon name={tab.icon} size="sm" variant={tab.isActive ? 'primary' : 'muted'} />
			{/if}
			<span class="name">{tab.name}</span>
			{#if tab.count}
				<span class="count">{tab.count}</span>
			{/if}
		</button>
	{/each}
</div>

<style lang="postcss">
	.tabs {
		display: flex;
		align-items: center;
		gap: 2px;
		border-bottom: 1px solid #003a661a;
	}

	.tabs .item {
		height: 48px;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
		cursor: pointer;
		padding: 0px 16px;
		border-bottom: 4px solid transparent;
		transition:
			color 0.3s,
			border-bottom 0.3s;
	}

	.tabs .item .name {
		font-size: 16px;
		font-weight: 400;
		line-height: 24px;
		text-align: center;
		color: rgba(0, 29, 51, 0.7);
		text-transform: capitalize;
		transition: font-weight 0.3s;
	}

	.tabs .item .count {
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
		text-align: center;
		color: rgba(0, 29, 51, 0.7);
		min-width: 24px;
		height: 24px;
		background-color: rgba(0, 73, 128, 0.06);
		border-radius: 50%;
		padding: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.tabs .item.active {
		border-bottom: 4px solid #007acc;
	}

	.tabs .item.active .name {
		color: #007acc;
		font-weight: 600;
	}

	.tabs--disabled {
		opacity: 0.5;
		pointer-events: none;
	}
</style>
